import { callable } from './callable'
import { doc, onSnapshot, type Unsubscribe } from 'firebase/firestore'
import { firestoreDb } from './firebase'
import type { OpsPrivacySettingsDoc } from '../../functions-common/src/ops/privacy'

export interface RecordOpsRestrictedViewInput {
  workspaceId: string
  sourceType: 'REQUEST' | 'RECORD'
  sourceId: string
}

export interface RecordOpsRestrictedViewResult {
  ok: boolean
  audited: boolean
}

export async function recordOpsRestrictedView(
  input: RecordOpsRestrictedViewInput,
): Promise<RecordOpsRestrictedViewResult> {
  return callable<RecordOpsRestrictedViewInput, RecordOpsRestrictedViewResult>(
    'recordOpsRestrictedView',
    input,
  )
}

export interface SetOpsPrivacySettingsInput {
  workspaceId: string
  offlineMaxDays: number
}

export interface SetOpsPrivacySettingsResult {
  ok: boolean
  settings: OpsPrivacySettingsDoc
}

export async function setOpsPrivacySettings(
  input: SetOpsPrivacySettingsInput,
): Promise<SetOpsPrivacySettingsResult> {
  return callable<SetOpsPrivacySettingsInput, SetOpsPrivacySettingsResult>(
    'setOpsPrivacySettings',
    input,
  )
}

export function subscribeOpsPrivacySettings(
  workspaceId: string,
  onSettings: (settings: OpsPrivacySettingsDoc | null) => void,
): Unsubscribe {
  const ref = doc(firestoreDb, 'ops_privacy_settings', workspaceId)
  return onSnapshot(
    ref,
    (snap) => {
      if (!snap.exists()) {
        onSettings(null)
      } else {
        onSettings(snap.data() as OpsPrivacySettingsDoc)
      }
    },
    (err) => {
      console.warn('Failed to read ops_privacy_settings', err)
      onSettings(null)
    },
  )
}
